import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";

export const useRefetchCandidacies = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return () => {
    void queryClient.refetchQueries({
      queryKey: ["candidacies", currentCompanyId, currentJobId],
    });
  };
};
